import { render } from "./BreadcrumbPage.vue?vue&type=template&id=72c087ed&scoped=true"
import script from "./BreadcrumbPage.vue?vue&type=script&lang=js"
export * from "./BreadcrumbPage.vue?vue&type=script&lang=js"

import "./BreadcrumbPage.vue?vue&type=style&index=0&id=72c087ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c087ed"]])

export default __exports__